import { connect } from "react-redux";

import { addInstance } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { withResolvePaths } from "../../withResolvePaths";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { ControlValidationProps } from "../../Validations/ValidationProps";

import { AddRowButton } from "./AddRowButton";

export interface AddRowButtonContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    maxOccurs?: EvaluableProp<number>;
    viewModelSelect: ViewModelSelect;
    disabled?: boolean;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    validationPath?: AbsoluteModelPath;
    filteredUniqKey?: string;
}

const mapStateToProps = (state: FullFormState, props: AddRowButtonContainerProps) => {
    const { viewModelSelect, bindingPath, processEvaluableProp, disabled, maxOccurs } = props;
    const { error, warning } = getValidationResult(state, props);

    if (maxOccurs != undefined) {
        const instanceCount = viewModelSelect.children(state, bindingPath)?.length ?? 0;
        const evalMaxOccurs = processEvaluableProp(state, maxOccurs);
        return {
            disabled: disabled || instanceCount >= evalMaxOccurs,
            error: error,
            warning: warning,
        };
    }
    return {
        disabled: disabled,
        isReadOnly: state.settings.isReadOnly,
        error: error,
        warning: warning,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: AddRowButtonContainerProps) => ({
    onAddInstance: () => {
        dispatch(
            addInstance(ownProps.bindingPath, undefined, undefined, undefined, undefined, ownProps.filteredUniqKey)
        );
    },
});

const getValidationResult = (state: FullFormState, props: AddRowButtonContainerProps): ControlValidationProps => {
    const { viewModelSelect, bindingPath, validationPath } = props;
    const path = validationPath ?? bindingPath;
    const controlModel = path.isResolved()
        ? viewModelSelect.controlModel(state, path)
        : { error: undefined, warning: undefined };
    return { ...controlModel };
};

export const AddRowButtonContainer = withResolvePaths(
    withViewModelSelect(
        withEvaluators(
            withFocusManagement(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(withTestPageObjectRegistration(AddRowButton, x => [`add_row_button_${x.bindingPath}`]))
            )
        )
    )
);
